import { UpdateStudentDto } from '../../pages/users/api/dto/update/UpdateStudentDto'
import { UpdateStudentUI } from '../../pages/users/model/UpdateStudentUI'
import UpdateLicense from '../license/UpdateLicense'
import UpdateLicenses from '../license/UpdateLicenses'
import UpdateUser from './UpdateUser'
import User from './User'

class UpdateStudent {
  private constructor(user: UpdateUser, licenses: UpdateLicenses) {
    this.user = user
    this.licenses = licenses
  }

  private readonly user: UpdateUser
  private readonly licenses: UpdateLicenses

  addLicense(id: string): void {
    this.licenses.addLicense(id)
  }

  removeLicense(id: string): void {
    this.licenses.removeLicense(id)
  }

  updateLicense(updateLicense: UpdateLicense): void {
    this.licenses.updateLicense(updateLicense)
  }

  findLicense(id: string): UpdateLicense {
    return this.licenses.findLicense(id)
  }

  isValid(): boolean {
    // TODO: implement a proper validation mechanism...
    return true
  }

  toUI(): UpdateStudentUI {
    return {
      updateUser: this.user.toUI(),
      updateLicenses: this.licenses.toUI(),
    } satisfies UpdateStudentUI
  }

  toDto(): UpdateStudentDto {
    return {
      user: this.user.toDto(),
      licenses: this.licenses.toDto(),
    }
  }

  static fromStudentUI(updateStudentUI: UpdateStudentUI): UpdateStudent {
    const { updateUser, updateLicenses } = updateStudentUI

    const user = UpdateUser.fromUpdateUserUI(updateUser)
    const licenses = UpdateLicenses.fromUpdateLicensesUI(updateLicenses)

    return new UpdateStudent(user, licenses)
  }

  static fromStudent(user: User): UpdateStudent {
    const updateUser = UpdateUser.fromUser(user)
    const updateLicenses = UpdateLicenses.fromLicenses(
      user.getStudentLicenses(),
    )

    return new UpdateStudent(updateUser, updateLicenses)
  }
}

export default UpdateStudent
